import type { JSX } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { EducationFormFields } from './EducationFormFields';
import { useEducationFormState } from './EducationFormDialog.hooks';
import type { Education } from '../types/education.types';

interface EducationFormDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  candidateId: string;
  mode: 'create' | 'edit';
  education?: Education | null;
}

function FormButtons({
  isLoading,
  submitLabel,
  onClose,
}: {
  isLoading: boolean;
  submitLabel: string;
  onClose: () => void;
}): React.JSX.Element {
  return (
    <DialogFooter>
      <Button type="button" variant="outline" onClick={onClose}>
        Cancel
      </Button>
      <Button type="submit" disabled={isLoading}>
        {submitLabel}
      </Button>
    </DialogFooter>
  );
}

export function EducationFormDialog({
  open,
  onOpenChange,
  candidateId,
  mode,
  education,
}: EducationFormDialogProps): JSX.Element {
  const form = useEducationFormState({ candidateId, mode, education, onOpenChange });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>{form.title}</DialogTitle>
        </DialogHeader>
        <form onSubmit={form.onSubmit} className="space-y-4">
          <EducationFormFields
            register={form.register}
            errors={form.errors}
            setValue={form.setValue}
            watch={form.watch}
          />
          <FormButtons
            isLoading={form.isLoading}
            submitLabel={form.submitLabel}
            onClose={form.handleClose}
          />
        </form>
      </DialogContent>
    </Dialog>
  );
}
